import { LINK_INSTAGRAM, LINK_ORDER_CONTACT } from 'src/app/constants';
import { TFooterMenu } from './types';

export const footerMainMenu: TFooterMenu = [
  {
    title: 'BÜKIについて',
    link: '/about',
  }, {
    title: 'FAQ',
    link: '/faq',
  }, {
    title: 'お問い合わせ',
    link: '/contacts',
  }, {
    title: '法人向けサービス',
    link: '/collaboration',
  }, {
    title: '@buki.jp',
    href: LINK_INSTAGRAM,
    svgIconSrc: '/assets/images/icons/instagram.svg',
  },
];

export const footerSideMenu: TFooterMenu = [
  {
    title: '特定商取引法に基づく表示',
    link: LINK_ORDER_CONTACT,
  }, {
    title: '利用規約',
    link: '/terms',
  }, {
    title: 'プライバシーポリシー',
    link: '/policy',
  },
];
